/* HWS24 – „Mein Gerät": iPhone-Modell oder Xenon-Typ merken, passende Teile zeigen, Modell auf der Produktseite vorwählen.
   Gespeichert wird nur im Browser (localStorage hws-device): { iphone: {...} | null, car: {...} | null, last: 'iphone' | 'car' }. */
(() => {
  const KEY = 'hws-device';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sheet = document.querySelector('[data-hws-device-sheet]');
  let S = {};
  try { S = JSON.parse(document.querySelector('[data-hws-device-strings]').textContent); } catch (e) { /* ohne Texte keine Hinweise */ }
  const t = (key, map = {}) => Object.entries(map).reduce((s, [k, v]) => s.split(`__${k.toUpperCase()}__`).join(v), S[key] || '');
  const yrs = (y) => String(y).replace(/^ab /, `${t('since')} `);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  /* ---------- Speicher ---------- */
  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  };
  let state = read();
  const save = () => {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* privater Modus: gilt nur für diese Seite */ }
    document.dispatchEvent(new CustomEvent('hws:device', { detail: state }));
  };

  /* ---------- Normalisieren und Abgleich ---------- */
  // „iPhone 12/12Pro", „12 & 12 Pro", „16 e", „XS MAX" → ['12', '12 pro'], ['16e'], ['xs max']
  const norm = (s) => String(s).toLowerCase().replace(/iphone/g, ' ')
    .replace(/(\d)(pro|plus|mini|max)/g, '$1 $2').replace(/(\d)\s+e\b/g, '$1e').replace(/\s+/g, ' ').trim();
  const models = (value) => String(value).split(/\s*(?:&|\/|,|\+|\bund\b|\band\b)\s*/i).map(norm).filter(Boolean);
  const plugOf = (key) => {
    const n = parseInt(key, 10);
    return /^air\b/.test(key) || n >= 15 ? 'usb-c' : 'lightning';
  };
  const normPlug = (s) => String(s).toLowerCase().replace(/[\s_]/g, '').replace('usbc', 'usb-c').replace('typ-c', 'usb-c').replace('type-c', 'usb-c');
  const bulbsFromTitle = (title) => [...new Set((String(title).toUpperCase().match(/\bD[1-8][SR]\b/g) || []))];
  const split = (s) => (s ? String(s).split('|').map((v) => v.trim()).filter(Boolean) : []);

  const makeDevice = (type, label, extra = {}) => {
    if (type === 'iphone') {
      const key = norm(label);
      return { type, label, key, plug: plugOf(key) };
    }
    const bulbs = String(label).toUpperCase().split(/[\/,\s]+/).filter(Boolean);
    return { type, label: extra.vehicle ? `${extra.vehicle} · ${bulbs.join('/')}` : `Xenon ${bulbs.join('/')}`, bulbs, bulb: bulbs[0], vehicle: extra.vehicle || '', sel: extra.sel || null };
  };

  // Welche Geräteart betrifft ein Produkt, und passt es? → { type, fit: true|false, values: [Optionswerte, die passen] } oder null
  function fitOf(el) {
    const d = el.dataset;
    const ms = split(d.hwsFitModels);
    const plugs = split(d.hwsFitPlugs);
    const tags = (d.hwsFitTags || '').toLowerCase().split(/[\s,]+/).filter(Boolean);
    let bulbs = split(d.hwsFitBulbs);
    if (!bulbs.length && !ms.length && !plugs.length) bulbs = bulbsFromTitle(d.hwsFitTitle);
    if (ms.length || plugs.length || tags.some((x) => /iphone|lightning|usb-c/.test(x))) {
      const dev = state.iphone;
      if (!dev) return { type: 'iphone', fit: null, values: [] };
      if (ms.length) {
        const values = ms.filter((v) => models(v).includes(dev.key));
        return { type: 'iphone', fit: values.length > 0, values, option: 'models' };
      }
      if (plugs.length) {
        const values = plugs.filter((v) => normPlug(v) === dev.plug);
        return { type: 'iphone', fit: values.length > 0, values, option: 'plugs' };
      }
      return { type: 'iphone', fit: tags.includes('iphone') || tags.includes(dev.plug), values: [] };
    }
    if (bulbs.length) {
      const dev = state.car;
      if (!dev) return { type: 'car', fit: null, values: [] };
      const want = dev.bulbs || [dev.bulb];
      const values = bulbs.filter((v) => want.includes(v.toUpperCase()));
      return { type: 'car', fit: values.length > 0, values, option: d.hwsFitBulbs ? 'bulbs' : '' };
    }
    return null;
  }

  /* ---------- Einstiege (Hero, Menü, Kategorie-Leiste) ---------- */
  const resultsUrl = sheet ? sheet.dataset.resultsUrl : '/pages/mein-geraet';
  const current = () => state[state.last] || state.iphone || state.car || null;
  function renderEntries() {
    const dev = current();
    document.documentElement.dataset.hwsDevice = dev ? dev.type : 'none';
    document.querySelectorAll('[data-hws-device-label]').forEach((el) => {
      el.textContent = dev ? dev.label : el.dataset.empty || t('bar_empty');
    });
    document.querySelectorAll('[data-hws-device-sub]').forEach((el) => {
      el.textContent = dev ? t('bar_sub') : t('bar_empty_sub');
    });
  }
  document.addEventListener('click', (event) => {
    const entry = event.target.closest('[data-hws-device-entry]');
    const opener = event.target.closest('[data-hws-device-open]');
    if (opener) { event.preventDefault(); openSheet(opener.dataset.tab); return; }
    if (entry && !current()) { event.preventDefault(); openSheet(entry.dataset.tab); }
  });

  /* ---------- Auswahl-Fenster ---------- */
  let afterPick = null;
  function selectTab(type) {
    if (!sheet) return;
    sheet.querySelectorAll('[data-hws-devtab]').forEach((tab) => {
      const on = tab.dataset.hwsDevtab === type;
      tab.setAttribute('aria-selected', String(on));
      tab.tabIndex = on ? 0 : -1;
      document.getElementById(tab.getAttribute('aria-controls')).hidden = !on;
    });
    sheet.dispatchEvent(new CustomEvent('hws:tab', { detail: type }));
    syncSheet();
  }
  // iPhone-Auswahl in zwei Schritten: erst Nummer (Serie), dann Modell. Gewählt ist erst nach dem Knopf unten.
  let pending = null; // vorgemerktes Modell (Label), noch nicht gespeichert
  let vehiclePending = () => null; // vollständig gewähltes Auto im Reiter „Auto" (initVehicles)
  // kurze Bestätigung unten im Bild, mit Weg zu den passenden Teilen
  let toastTimer = 0;
  function confirmToast(dev) {
    let el = document.querySelector('.hws-devtoast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'hws-devtoast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    const onResults = !!document.querySelector('[data-hws-device-results-page]');
    el.innerHTML = `<span>${esc(t('saved', { device: dev.label }))}</span>${onResults ? '' : `<a href="${esc(resultsUrl)}">${esc(t('show_results'))}</a>`}`;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 5000);
  }
  let series = null; // angezeigte Serie (Index)
  const seriesOf = (label) => {
    const chip = sheet && sheet.querySelector(`[data-hws-device-models] [data-hws-device-pick="iphone"][data-label="${CSS.escape(label)}"]`);
    return chip ? chip.dataset.series : null;
  };
  function showSeries(idx) {
    series = idx;
    sheet.querySelectorAll('[data-hws-device-series]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.hwsDeviceSeries === idx)));
    sheet.querySelectorAll('[data-hws-device-group]').forEach((g) => { g.hidden = g.dataset.hwsDeviceGroup !== idx; });
    const models = sheet.querySelector('[data-hws-device-models]');
    if (models) models.hidden = idx === null;
  }
  function syncSheet() {
    if (!sheet) return;
    const chosen = pending || (state.iphone && state.iphone.label) || null;
    sheet.querySelectorAll('[data-hws-device-pick="iphone"]').forEach((chip) => {
      chip.setAttribute('aria-pressed', String(!!chosen && norm(chip.dataset.label) === norm(chosen)));
    });
    const tab = sheet.querySelector('[data-hws-devtab][aria-selected="true"]');
    const type = tab ? tab.dataset.hwsDevtab : 'iphone';
    const footer = sheet.querySelector('[data-hws-device-footer]');
    const has = !!state[type];
    const clear = footer.querySelector('[data-hws-device-clear]');
    if (clear) { clear.textContent = t(`clear_${type}`) || clear.textContent; clear.disabled = !has; }
    const results = footer.querySelector('[data-hws-device-results]');
    if (results) {
      let fresh = false;
      if (type === 'iphone') fresh = !!pending && (!state.iphone || norm(pending) !== state.iphone.key);
      else {
        const v = vehiclePending();
        fresh = !!v && (!state.car || state.car.label !== makeDevice('car', v.label, v.extra).label);
      }
      results.disabled = !fresh;
    }
    const see = sheet.querySelector('[data-hws-device-see]');
    if (see) {
      see.hidden = !has || !!document.querySelector('[data-hws-device-results-page]');
      if (has) see.querySelector('[data-hws-device-see-text]').textContent = t('see_all', { device: state[type].label });
      see.dataset.type = type;
    }
  }
  // Während etwas lädt oder das Fenster schließt: alles sperren
  function setBusy(on) {
    if (!sheet) return;
    if (on) sheet.dataset.busy = '1'; else delete sheet.dataset.busy;
    sheet.setAttribute('aria-busy', String(!!on));
  }
  function openSheet(type, then) {
    if (!sheet || typeof sheet.showModal !== 'function') return;
    afterPick = then || null;
    pending = null;
    showSeries(state.iphone ? seriesOf(state.iphone.label) : null);
    selectTab(type || state.last || 'iphone');
    syncSheet();
    setBusy(false);
    sheet.showModal();
    document.documentElement.classList.add('hws-dialog-open');
    sheet.querySelector('.hws-ui-card').focus({ preventScroll: true });
    const pressed = sheet.querySelector('[role="tabpanel"]:not([hidden]) [aria-pressed="true"]');
    if (pressed) pressed.scrollIntoView({ block: 'center' });
  }
  function closeSheet() {
    if (!sheet || !sheet.open || sheet.classList.contains('is-closing')) return;
    if (reduceMotion) return sheet.close();
    sheet.classList.add('is-closing');
    setTimeout(() => { sheet.classList.remove('is-closing'); sheet.close(); }, 220);
  }
  function pick(type, label, extra) {
    if (sheet && sheet.dataset.busy) return;
    setBusy(true);
    state[type] = makeDevice(type, label, extra);
    state.last = type;
    save();
    syncSheet();
    closeSheet();
    const then = afterPick;
    afterPick = null;
    // keine Weiterleitung: man bleibt auf der Seite, Karten/Produktseite zeigen sofort, was passt
    if (!document.querySelector('[data-hws-fit-pdp]')) confirmToast(state[type]);
    if (then) then();
  }
  if (sheet) {
    sheet.addEventListener('click', (event) => {
      if (sheet.dataset.busy) return;
      const ser = event.target.closest('[data-hws-device-series]');
      if (ser) {
        const idx = ser.dataset.hwsDeviceSeries;
        if (pending && seriesOf(pending) !== idx) pending = null;
        showSeries(idx);
        syncSheet();
        const group = sheet.querySelector(`[data-hws-device-group="${idx}"]`);
        if (group && group.scrollIntoView) group.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
        return;
      }
      const chip = event.target.closest('[data-hws-device-pick]');
      if (chip) {
        // nur vormerken – erst der Knopf unten übernimmt
        pending = chip.dataset.label;
        if (chip.dataset.series && chip.dataset.series !== series) showSeries(chip.dataset.series);
        syncSheet();
        return;
      }
      const tab = event.target.closest('[data-hws-devtab]');
      if (tab) return selectTab(tab.dataset.hwsDevtab);
      if (event.target.closest('[data-hws-device-close]') || event.target === sheet) return closeSheet();
      const go = event.target.closest('[data-hws-device-results]');
      if (go && !go.disabled) {
        const type = sheet.querySelector('[data-hws-devtab][aria-selected="true"]').dataset.hwsDevtab;
        if (type === 'iphone' && pending) { const label = pending; pending = null; return pick('iphone', label); }
        const v = type === 'car' ? vehiclePending() : null;
        if (v) return pick('car', v.label, v.extra);
        return;
      }
      const see = event.target.closest('[data-hws-device-see]');
      if (see) { state.last = see.dataset.type || state.last; save(); setBusy(true); return; }
      if (event.target.closest('[data-hws-device-clear]')) {
        const type = sheet.querySelector('[data-hws-devtab][aria-selected="true"]').dataset.hwsDevtab;
        if (!state[type] || sheet.dataset.busy) return;
        state[type] = null;
        if (type === 'iphone') { pending = null; showSeries(null); }
        state.last = state.iphone ? 'iphone' : state.car ? 'car' : null;
        save();
        syncSheet();
        closeSheet();
      }
    });
    sheet.addEventListener('keydown', (event) => {
      const tab = event.target.closest('[data-hws-devtab]');
      if (!tab || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      const tabs = [...sheet.querySelectorAll('[data-hws-devtab]')];
      const next = tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      selectTab(next.dataset.hwsDevtab);
      next.focus();
    });
    sheet.addEventListener('cancel', (event) => { event.preventDefault(); closeSheet(); });
    sheet.addEventListener('close', () => { if (!sheet.open) { document.documentElement.classList.remove('hws-dialog-open'); setBusy(false); } });

    // Fahrzeuge: assets/hws-vehicles.json (aus den eBay-Kompatibilitätslisten) + optionale Zeilen aus den Theme-Einstellungen
    const vehicleBox = sheet.querySelector('[data-hws-vehicle]');
    if (vehicleBox) initVehicles(vehicleBox);
  }

  function initVehicles(box) {
    const makeSel = box.querySelector('[data-hws-vehicle-make]');
    const modelSel = box.querySelector('[data-hws-vehicle-model]');
    const genSel = box.querySelector('[data-hws-vehicle-gen]');
    const result = box.querySelector('[data-hws-vehicle-result]');
    const text = box.querySelector('[data-hws-vehicle-text]');
    let data = null;
    let loading = null;
    // Felder erscheinen erst, wenn der vorige Schritt gewählt ist – nichts sieht anklickbar aus, was nichts tut
    const field = (sel) => sel.closest('.hws-field');
    const reset = (sel) => { sel.length = 1; sel.disabled = true; field(sel).hidden = true; };
    const fill = (sel, values) => {
      reset(sel);
      values.forEach(([value, label]) => sel.add(new Option(label, value)));
      sel.disabled = values.length === 0;
      field(sel).hidden = values.length === 0;
      if (values.length === 1) sel.value = values[0][0];
    };
    reset(modelSel);
    reset(genSel);
    // eigene Auswahlliste statt nativem Dropdown
    if (window.hwsEnhanceSelect) [makeSel, modelSel, genSel].forEach((sel) => window.hwsEnhanceSelect(sel, { search: t('search'), empty: t('no_results') }));
    const refresh = (...sels) => sels.forEach((sel) => sel.hwsRender && sel.hwsRender());
    const gens = () => ((data[makeSel.value] || {})[modelSel.value] || []);
    const current = () => gens()[+genSel.value];
    const showResult = () => {
      const g = genSel.value !== '' ? current() : null;
      result.hidden = !g;
      if (!g) return;
      const name = `${makeSel.value} ${modelSel.value}${g[0] ? ` (${g[0]})` : ''}`;
      text.textContent = t(g[2].length > 1 ? 'vehicle_needs_multi' : 'vehicle_needs', { device: `${name}${g[1] ? `, ${yrs(g[1])}` : ''}`, bulb: g[2].join(' / ') });
      const hsnWrap = result.querySelector('[data-hws-hsn-wrap]');
      if (hsnWrap) {
        hsnWrap.open = g[2].length > 1;
        const form = hsnWrap.querySelector('[data-hws-hsn]');
        if (form) form.dataset.vehicle = `${name}${g[1] ? `, ${yrs(g[1])}` : ''} – ${g[2].join('/')}`;
      }
    };
    const onMake = () => {
      fill(modelSel, Object.keys(data[makeSel.value] || {}).sort((a, b) => a.localeCompare(b, 'de', { numeric: true })).map((m) => [m, m]));
      reset(genSel);
      if (modelSel.value) onModel(); else showResult();
    };
    const onModel = () => {
      fill(genSel, gens().map((g, i) => [String(i), g[0] ? `${g[0]} · ${yrs(g[1])}` : yrs(g[1])]));
      showResult();
    };
    makeSel.addEventListener('change', onMake);
    modelSel.addEventListener('change', onModel);
    genSel.addEventListener('change', showResult);
    // vollständig gewähltes Fahrzeug – übernommen wird mit dem Knopf unten („Übernehmen")
    vehiclePending = () => {
      const g = genSel.value !== '' && data ? current() : null;
      if (!g) return null;
      return { label: g[2].join('/'), extra: { vehicle: `${makeSel.value} ${modelSel.value}${g[0] ? ` (${g[0]})` : ''}`, sel: [makeSel.value, modelSel.value, g[0], g[1]] } };
    };
    [makeSel, modelSel, genSel].forEach((sel) => sel.addEventListener('change', () => syncSheet()));

    function load() {
      if (loading) return loading;
      makeSel.disabled = true;
      makeSel.options[0].textContent = t('loading');
      refresh(makeSel);
      loading = fetch(box.dataset.src).then((r) => r.json()).catch(() => ({ makes: {} })).then((json) => {
        data = json.makes || {};
        // Zusätzliche Fahrzeuge aus den Theme-Einstellungen: „Marke | Modell | Baujahre | Brenner"
        const extra = box.querySelector('[data-hws-vehicles]');
        if (extra) {
          try {
            JSON.parse(extra.textContent).split(/\r?\n/).map((l) => l.split('|').map((x) => x.trim())).filter((r) => r.length >= 4 && r[0] && r[1] && r[3])
              .forEach(([mk, md, yrs, bulb]) => {
                data[mk] = data[mk] || {};
                (data[mk][md] = data[mk][md] || []).push(['', yrs, bulb.toUpperCase().split(/[\/,\s]+/).filter(Boolean)]);
              });
          } catch (e) { /* Textfeld leer oder fehlerhaft */ }
        }
        makeSel.options[0].textContent = t('choose_option');
        Object.keys(data).sort((a, b) => a.localeCompare(b, 'de')).forEach((mk) => makeSel.add(new Option(mk, mk)));
        makeSel.disabled = false;
        refresh(makeSel);
        // gespeichertes Auto wieder auswählen
        const sel = state.car && state.car.sel;
        if (sel && data[sel[0]]) {
          makeSel.value = sel[0]; onMake();
          if (data[sel[0]][sel[1]]) {
            modelSel.value = sel[1]; onModel();
            const i = gens().findIndex((g) => g[0] === sel[2] && g[1] === sel[3]);
            if (i > -1) { genSel.value = String(i); showResult(); }
          }
          refresh(makeSel, modelSel, genSel);
        }
      });
      return loading;
    }
    sheet.addEventListener('hws:tab', (event) => { if (event.detail === 'car') load(); });
  }

  /* ---------- Produktkarten: „Passt" ---------- */
  function renderCards(root = document) {
    root.querySelectorAll('.card-wrapper[data-hws-fit-title]').forEach((card) => {
      const fit = fitOf(card);
      const host = card.querySelector('.card__content .card-information') || card.querySelector('.card-information');
      let chip = card.querySelector('.hws-fitchip');
      if (!fit || fit.fit !== true || !host) { if (chip) chip.remove(); return; }
      if (!chip) {
        chip = document.createElement('p');
        chip.className = 'hws-fitchip';
        host.prepend(chip);
      }
      chip.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg><span>${esc(t('chip', { device: state[fit.type].label }))}</span>`;
    });
  }

  /* ---------- Ergebnisseite ---------- */
  function renderResults() {
    const page = document.querySelector('[data-hws-device-results-page]');
    if (!page) return;
    const type = page.dataset.type && state[page.dataset.type] ? page.dataset.type : (current() || {}).type;
    const dev = type ? state[type] : null;
    page.querySelectorAll('[data-hws-devres-switch]').forEach((btn) => {
      const d = state[btn.dataset.hwsDevresSwitch];
      btn.hidden = !d || !(state.iphone && state.car);
      btn.setAttribute('aria-pressed', String(btn.dataset.hwsDevresSwitch === type));
      if (d) btn.querySelector('span').textContent = d.label;
    });
    page.dataset.state = dev ? 'set' : 'empty';
    const title = page.querySelector('[data-hws-devres-title]');
    if (title) title.textContent = dev ? t(`results_title_${dev.type}`, { device: dev.label }) : title.dataset.empty;
    const items = [...page.querySelectorAll('[data-hws-devres-item]')];
    let count = 0;
    const exact = [];
    const loose = [];
    items.forEach((li) => {
      const card = li.querySelector('.card-wrapper[data-hws-fit-title]');
      const fit = card && dev ? fitOf(card) : null;
      const show = !!fit && fit.type === dev.type && fit.fit === true;
      li.hidden = !show;
      if (show) { count += 1; (fit.option === 'models' ? exact : loose).push(li); }
    });
    const grid = page.querySelector('[data-hws-devres-grid]');
    if (grid) [...exact, ...loose].forEach((li) => grid.appendChild(li));
    const countEl = page.querySelector('[data-hws-devres-count]');
    if (countEl) countEl.textContent = dev ? t(count === 1 ? 'results_one' : 'results_other', { count: String(count) }) : '';
    const empty = page.querySelector('[data-hws-devres-empty]');
    if (empty) empty.hidden = !dev || count > 0;
    const hsn = page.querySelector('[data-hws-devres-hsn]');
    if (hsn) {
      const multi = !!dev && dev.type === 'car' && (dev.bulbs || []).length > 1;
      hsn.hidden = !multi;
      if (multi) {
        hsn.querySelector('[data-hws-devres-warn]').textContent = t('hsn_multi', { bulb: dev.bulbs.join(' / ') });
        const form = hsn.querySelector('[data-hws-hsn]');
        if (form) form.dataset.vehicle = dev.label;
      }
    }
  }

  /* ---------- HSN/TSN prüfen lassen: Eingaben prüfen, dann WhatsApp mit fertiger Nachricht ---------- */
  const hsnOk = (v) => /^\d{4}$/.test(v);
  const tsnOk = (v) => /^[A-Z0-9]{3}$/.test(v);
  document.addEventListener('input', (event) => {
    const form = event.target.closest('[data-hws-hsn]');
    if (!form) return;
    const input = event.target;
    // HSN nur Ziffern, TSN Großbuchstaben/Ziffern – Tippfehler gar nicht erst zulassen
    if (input.name === 'hsn') input.value = input.value.replace(/\D/g, '').slice(0, 4);
    if (input.name === 'tsn') input.value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 3);
    form.querySelector('.hws-hsn__send').disabled = !(hsnOk(form.elements.hsn.value) && tsnOk(form.elements.tsn.value));
  });
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-hws-hsn]');
    if (!form) return;
    event.preventDefault();
    const hsn = form.elements.hsn.value;
    const tsn = form.elements.tsn.value;
    if (!hsnOk(hsn) || !tsnOk(tsn)) return;
    const vehicle = form.dataset.vehicle ? t('hsn_vehicle', { vehicle: form.dataset.vehicle }) : '';
    const text = t('hsn_message', { hsn, tsn, vehicle });
    window.open(`https://wa.me/${form.dataset.wa}?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
  });
  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-hws-devres-switch]');
    if (!btn) return;
    state.last = btn.dataset.hwsDevresSwitch;
    save();
  });

  /* ---------- Produktseite: Hinweis + Modell vorwählen ---------- */
  const pdp = document.querySelector('[data-hws-fit-pdp]');
  let variants = [];
  let optionNames = [];
  if (pdp) {
    try { variants = JSON.parse(pdp.querySelector('[data-hws-fit-variants]').textContent); } catch (e) { variants = []; }
    try { optionNames = JSON.parse(pdp.querySelector('[data-hws-fit-options]').textContent); } catch (e) { optionNames = []; }
  }
  const info = pdp && pdp.closest('product-info');
  const fieldsets = () => (info ? [...info.querySelectorAll('variant-selects fieldset')] : []);
  const selectedOptions = () => fieldsets().map((fs) => (fs.querySelector('input:checked') || {}).value || '');
  const optionIndex = (fit) => {
    const re = fit.option === 'models' ? /modell|model|kompatib/i : fit.option === 'plugs' ? /anschluss|stecker/i : /sockel/i;
    return optionNames.findIndex((n) => re.test(n));
  };
  function bestVariant(fit) {
    const idx = optionIndex(fit);
    if (idx < 0) return { idx, variant: null, candidates: [] };
    const cur = selectedOptions();
    const candidates = variants.filter((v) => fit.values.includes(v.o[idx]));
    const same = (v) => v.o.every((val, i) => i === idx || val === cur[i]);
    const variant = candidates.find((v) => v.a && same(v)) || candidates.find((v) => v.a) || null;
    return { idx, variant, candidates };
  }
  const waitVariant = () => new Promise((resolve) => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return setTimeout(resolve, 1500);
    let done = false;
    const unsub = subscribe(PUB_SUB_EVENTS.variantChange, () => { if (!done) { done = true; unsub(); resolve(); } });
    setTimeout(() => { if (!done) { done = true; unsub(); resolve(); } }, 4000);
  });
  let applying = false;
  async function applyVariant(variant) {
    if (!variant || applying) return;
    applying = true;
    pdp.dataset.busy = '1';
    try {
      for (let i = 0; i < variant.o.length; i += 1) {
        const fs = fieldsets()[i];
        if (!fs) break;
        const input = [...fs.querySelectorAll('input[type="radio"]')].find((inp) => inp.value === variant.o[i]);
        if (!input || input.checked || input.disabled) continue;
        const wait = waitVariant();
        (fs.querySelector(`label[for="${CSS.escape(input.id)}"]`) || input).click();
        await wait;
      }
    } finally {
      applying = false;
      delete pdp.dataset.busy;
      renderPdp();
    }
  }
  function renderPdp() {
    if (!pdp) return;
    const box = pdp.querySelector('[data-hws-fit-hint]');
    const fit = fitOf(pdp);
    if (!fit) { box.hidden = true; return; }
    box.hidden = false;
    const dev = state[fit.type];
    const icon = (name) => (S.icons && S.icons[name]) || '';
    let html = '';
    let tone = 'ask';
    if (fit.fit === null) {
      html = `${icon(fit.type)}<span>${esc(t(`ask_${fit.type}`))}</span><button type="button" class="hws-fithint__btn" data-hws-device-open data-tab="${fit.type}">${esc(t('choose'))}</button>`;
    } else if (fit.fit === false) {
      tone = 'no';
      html = `${icon('info')}<span>${esc(t(`no_${fit.type}`, { device: dev.label }))}</span><a class="hws-fithint__btn" href="${esc(resultsUrl)}">${esc(t('no_link'))}</a>`;
    } else {
      const { idx, variant, candidates } = bestVariant(fit);
      const cur = selectedOptions();
      const selectedFits = idx < 0 || fit.values.includes(cur[idx]);
      if (idx >= 0 && !variant) {
        tone = 'soldout';
        html = `${icon('bell')}<span>${esc(t(`soldout_${fit.type}`, { device: dev.label }))}</span><button type="button" class="hws-fithint__btn" data-hws-fit-notify="${esc((candidates[0] || { o: [] }).o.join(' / '))}">${esc(t('notify'))}</button>`;
      } else if (!selectedFits) {
        tone = 'pick';
        html = `${icon(fit.type)}<span>${esc(t(`pick_${fit.type}`, { device: dev.label, value: variant.o[idx] }))}</span><button type="button" class="hws-fithint__btn" data-hws-fit-apply>${esc(t('apply'))}</button>`;
      } else {
        tone = 'yes';
        html = `${icon('check')}<span>${esc(t(`yes_${fit.type}`, { device: dev.label }))}</span><button type="button" class="hws-fithint__btn hws-fithint__btn--ghost" data-hws-device-open data-tab="${fit.type}">${esc(t('change'))}</button>`;
      }
    }
    box.dataset.tone = tone;
    box.innerHTML = html;
  }
  if (pdp) {
    pdp.addEventListener('click', (event) => {
      if (event.target.closest('[data-hws-fit-apply]')) {
        const fit = fitOf(pdp);
        if (fit && fit.fit) applyVariant(bestVariant(fit).variant);
      }
      const notify = event.target.closest('[data-hws-fit-notify]');
      if (notify) {
        const title = notify.dataset.hwsFitNotify;
        const opener = document.querySelector('[data-hws-restock-open]');
        if (!opener) return;
        opener.click();
        const select = document.querySelector('[data-hws-restock-variant]');
        const match = select && [...select.options].find((o) => o.textContent.trim() === title);
        if (match) { select.value = match.value; select.dispatchEvent(new Event('change')); }
      }
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => { if (!applying) setTimeout(renderPdp, 0); });
    }
  }
  function autoSelect(force) {
    if (!pdp) return;
    const fit = fitOf(pdp);
    if (!fit || fit.fit !== true) return;
    // Wer einen Link mit ?variant= geöffnet hat, hat schon gewählt
    if (!force && new URLSearchParams(location.search).has('variant')) return;
    const { idx, variant } = bestVariant(fit);
    if (idx >= 0 && variant && !fit.values.includes(selectedOptions()[idx])) applyVariant(variant);
  }

  /* ---------- Start ---------- */
  function renderAll() {
    renderEntries();
    renderCards();
    renderResults();
    renderPdp();
  }
  document.addEventListener('hws:device', () => {
    renderAll();
    autoSelect(true);
  });
  // Neu geladene Karten (Filter, Empfehlungen, Schnellkauf)
  new MutationObserver((list) => {
    if (list.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches('.card-wrapper') || n.querySelector('.card-wrapper'))))) renderCards();
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('storage', (event) => { if (event.key === KEY) { state = read(); renderAll(); } });

  renderAll();
  autoSelect(false);
  window.hwsDevice = { open: openSheet, get: () => state, fitOf };
})();
